// extracted by mini-css-extract-plugin
export var gif = "_lo-0";